import type { FrameworkName } from '@bolt/framework-detection';

export function supabaseEnvForFramework(framework: FrameworkName | undefined) {
  let frameworkPrefix = 'VITE_';

  if (framework === 'nextjs') {
    frameworkPrefix = 'NEXT_PUBLIC_';
  }

  if (framework === 'expo') {
    frameworkPrefix = 'EXPO_PUBLIC_';
  }

  const apiKeyEnvVar = `${frameworkPrefix}SUPABASE_ANON_KEY`;
  const databaseUrlEnvVar = `${frameworkPrefix}SUPABASE_URL`;

  return {
    apiKeyEnvVar,
    databaseUrlEnvVar,
  };
}

export function updateEnvFile(fileContent: string, environmentVariables: Record<string, string>) {
  const lines = fileContent.split('\n');

  for (const [key, value] of Object.entries(environmentVariables)) {
    findAndReplaceKey(lines, key, value);
  }

  return lines.join('\n');
}

function findAndReplaceKey(lines: Array<string>, key: string, value: string) {
  const keyIndex = lines.findIndex((line) => line.trim().startsWith(`${key}=`));

  const newKeyValue = `${key}=${value}`;

  if (keyIndex !== -1) {
    lines.splice(keyIndex, 1, newKeyValue);
  } else {
    lines.push(newKeyValue);
  }
}
